import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png';
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdArrowCircleLeft, MdArrowCircleRight, MdCircle, MdEmail, MdLock, MdLogin, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked, MdTranscribe, MdTranslate } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import {
  STR_APP_NAME,
  STR_CHANGE_LANGUAGE,
  STR_CHANGE,
  STR_CONFIRM,
  STR_CONTINUE,
  STR_ENTER,
  STR_ENTER_EMAIL_ADDRESS,
  STR_ENTER_OTP,
  STR_ENTER_YOUR_PHONE_NUMBER,
  STR_FORGOT_PASSWORD,
  STR_GET_STARTED,
  STR_HEALTH,
  STR_INVALID_CONFIRM_PASSWORD,
  STR_INVALID_EMAIL,
  STR_INVALID_OTP,
  STR_INVALID_PASSWORD,
  STR_INVALID_PHONE,
  STR_PASSWORD,
  STR_PLEASE_WAIT,
  STR_RELATIONSHIPS,
  STR_RESEND_OTP,
  STR_STORIES,
  STR_USE_EMAIL,
  STR_USE_PHONE,
  STR_WELCOME,
  STR_LOGIN_TO_CONTINUE,
  STR_LOGIN_NOW,
  STR_YOUR_PHONE,
  STR_PHONE_NUMBER,
  STR_YOUR_OTP_VERIFICATION,
  STR_CHANGE_EMAIL_OR_PHONE,
  STR_FULLNAME,
  STR_ENTER_FULLNAME,
  STR_OTP_WAS_SENT,
  STR_WELCOME_BACK,
  STR_INTRO_2,
  STR_EMAIL,
  STR_YOUR_EMAIL
} from "../Strings";

export default function Login(props) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loginStep, setLoginStep] = useState("identity");
  const [identity, setIdentity] = useState('phone');
  const [requestFullname, setRequestFullname] = useState(false);
  const [fullname, setFullname] = useState('');

  async function init() {
    const storedPhone = getCookie("phone");
    const storedEmail = getCookie("email");
    const storedLoginStep = getCookie("loginStep");

    if (storedLoginStep) {
      setLoginStep(storedLoginStep);

      if (storedPhone) {
        setPhone(storedPhone);
        setIdentity('phone');
      }

      if (storedEmail) {
        setEmail(storedEmail);
        setIdentity('email');
      }
    }
  }

  async function resendOtp() {
    if (!loading) {
      if (String(phone).trim().length >= 9 || String(email).trim().length > 0) {

        setLoading(true);
        await callApi(
          "resend-otp",
          {
            phone: (phone) ? `255${parseInt(phone, 10)}` : '',
            identity,
            email
          }
        ).then((response) => {
          if (response.status === 1) {
            setCookie('phone', phone);
            setCookie('email', email);
            setCookie('loginStep', response.nextLoginStep);
            setLoginStep(response.nextLoginStep);

            if(!response.fullname) {
              setRequestFullname(true);
            } else {
              setRequestFullname(false)
            }

            appContext.tellMessage(STR_OTP_WAS_SENT[appContext.language]);

          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError(STR_INVALID_PHONE[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  async function phoneLogin() {
    if (!loading) {
      if (String(phone).trim().length >= 9) {

        setLoading(true);
        await callApi(
          "phone-login",
          {
            phone: (phone) ? `255${parseInt(phone, 10)}` : '',
          }
        ).then((response) => {
          if (response.status === 1) {
            setCookie('phone', phone);
            setCookie('loginStep', response.nextLoginStep);
            setLoginStep(response.nextLoginStep);

            if(!response.fullname) {
              setRequestFullname(true);
            } else {
              setRequestFullname(false)
            }

          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError(STR_INVALID_PHONE[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  async function emailLogin() {
    if (!loading) {
      if (String(email).trim().length > 0) {

        setLoading(true);
        await callApi(
          "email-login",
          {
            email,
          }
        ).then((response) => {
          if (response.status === 1) {
            setCookie('email', email);
            setCookie('loginStep', response.nextLoginStep);
            setLoginStep(response.nextLoginStep);

            if(!response.fullname) {
              setRequestFullname(true);
            } else {
              setRequestFullname(false)
            }

          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError(STR_INVALID_EMAIL[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  async function forgotPassword() {
    if (!loading) {
      if (String(phone).trim().length >= 9 || String(email).trim().length > 0) {

        setLoading(true);
        await callApi(
          "forgot-password",
          {
            phone: (phone) ? `255${parseInt(phone, 10)}` : '',
            email,
            identity,
          }
        ).then((response) => {
          if (response.status === 1) {
            setCookie('phone', phone);
            setCookie('loginStep', response.nextLoginStep);
            setLoginStep(response.nextLoginStep);

          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError(STR_INVALID_PHONE[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  async function otpLogin() {
    if (!loading) {
      if (otp.trim().length === 6) {
        if(
          (requestFullname && fullname.trim().length > 0) ||
          !requestFullname
        ) {

          if(password && password.trim().length >= 6) {
            if(password === confirm) {
              //...
              setLoading(true);
              await callApi(
                "otp-login",
                {
                  phone: (phone) ? `255${parseInt(phone, 10)}` : '',
                  otp,
                  identity,
                  password,
                  email,
                  fullname,
                }
              ).then((response) => {
                if (response.status === 1) {
                  setCookie('phone', '');
                  setCookie('email', '');
                  setCookie('loginStep', '');

                  setCookie("userId", response.user.id);
                  setCookie("userToken", response.user.token);

                  appContext.navTo({
                    item: 'hotels',
                  })

                  //refresh app
                  appContext.refresh(); //delay hack

                  appContext.tellMessage(STR_WELCOME[appContext.language]);
                } else {
                  appContext.tellError(response.msg);
                }
              })
              setLoading(false);
              //...
            } else {
              appContext.tellError(STR_INVALID_CONFIRM_PASSWORD[appContext.language]);
            }
          } else {
            appContext.tellError(STR_INVALID_PASSWORD[appContext.language]);
          }
          
        } else {
          appContext.tellError()
        }
          
      } else {
        appContext.tellError(STR_INVALID_OTP[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }



  async function passwordLogin() {
    if (!loading) {
      if (password.trim().length >= 6) {
        setLoading(true);
        await callApi(
          "password-login",
          {
            phone: (phone) ? `255${parseInt(phone, 10)}` : '',
            email,
            identity,
            otp,
            password,
          }
        ).then((response) => {
          if (response.status === 1) {
            setCookie('phone', '');
            setCookie('loginStep', '');

            setCookie("userId", response.user.id);
            setCookie("userToken", response.user.token);

            appContext.navTo({
              item: 'hotels',
            })

            //refresh app
            appContext.refresh(); //delay hack

            appContext.tellMessage(STR_WELCOME[appContext.language]);
          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError(STR_INVALID_PASSWORD[appContext.language])
      }

    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
    
  }, [loading])

  return (
    <div
      className="bg-sub-gradient"
      style={{
        width: "100%",
        minHeight: "100%",
      }}
    >
      <div
        style={{
          maxWidth: "500px",
          margin: "0 auto",
        }}
      >

      

        {
          (loginStep === 'identity') ?
          <div
            className="container"
            
          >
            <div
              className="text-center"
              style={{
                paddingTop: "var(--topBarHeight)",
                paddingBottom: "30px",
              }}
            >
              <img
                src={logo}
                style={{
                  width: "120px",
                  height: "auto",
                }}
                
              />
              <h6
                className="font-light"
                style={{
                  fontSize: "28px",
                }}
              >
                HOTELS
              </h6>
              <hr/>
              <h6
                className="font-bold text-primary"
                style={{
                  fontSize: "20px",
                }}
              >
                "<i>{STR_INTRO_2[appContext.language]}</i>"
              </h6>
            </div>

            {
              (identity === 'phone') ?
              <div
                style={{
                  maxWidth: "420px",
                  margin: "10px auto",
                  padding: "30px",
                  borderRadius: "20px"
                }}
                className="mShadow5 bg-surface"
              >

                <h6
                  style={{
                    fontSize: "24px"
                  }}
                  className="font-bold"
                >
                  {STR_YOUR_PHONE[appContext.language]}!
                </h6>

                <div
                  style={{
                    marginTop: "40px",
                    marginBottom: "40px",
                  }}
                >
                  <label>{STR_PHONE_NUMBER[appContext.language]}</label>
                  
                  <div
                    className="input-group"
                  >
                    <span
                      className="input-group-text font-semi-bold text-primary"
                      style={{
                        fontSize: "16px"
                      }}
                    >
                      +255
                    </span>
                    <input
                      className="form-control"
                      onChange={(e) => setPhone(_prev => {
                        if (Number(e.target.value)) {
                          return Number(e.target.value);
                        } else if (String(e.target.value).trim().length === 0) {
                          return "";
                        } else {
                          return _prev;
                        }
                      })}
                      value={phone}
                      maxLength={10}
                      placeholder="XXX XXX XXX"
                      type="text"
                      style={{
                        fontSize: "16px"
                      }}
                    />
                  </div>
                  <div className="form-text mb-3 mt-3">
                    {STR_ENTER_YOUR_PHONE_NUMBER[appContext.language]}
                  </div>
                  
                </div>


                <div
                  className=""
                >
                  <h6
                    style={{
                      cursor: "pointer",
                      fontSize: "14px"
                    }}
                    className="text-primary font-bold text-end"
                    onClick={() => {
                      setIdentity('email');
                    }}
                  >
                    
                    {STR_USE_EMAIL[appContext.language]}
                  </h6>
                  
                  <h6
                    style={{
                      cursor: "pointer",
                      fontSize: "14px"
                    }}
                    className="text-primary font-bold text-end"
                    onClick={() => appContext.changeLanguage()}
                  >
                    
                    {STR_CHANGE_LANGUAGE[appContext.language]}
                    <MdTranslate size={24}/>
                  </h6>

                  
                </div>

              </div>
              :""
            }


            {
              (identity === 'email') ?
              <div
                style={{
                  maxWidth: "420px",
                  margin: "10px auto",
                  padding: "30px",
                  borderRadius: "20px"
                }}
                className="mShadow5 bg-surface"
              >

                <h6
                  style={{
                    fontSize: "24px"
                  }}
                  className="font-bold"
                >
                  {STR_YOUR_EMAIL[appContext.language]}!
                </h6>

                <div
                  style={{
                    marginTop: "40px",
                    marginBottom: "40px",
                  }}
                >
                  <label>{STR_EMAIL[appContext.language]}</label>
                  
                  <div
                    className="input-group"
                  >
                    <span
                      className="input-group-text font-semi-bold text-primary"
                      style={{
                        fontSize: "16px"
                      }}
                    >
                      <MdEmail/>
                    </span>
                    <input
                      className="form-control"
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                      placeholder="john@email.com"
                      type="email"
                      style={{
                        fontSize: "16px"
                      }}
                    />
                  </div>
                  
                  
                </div>


                <div
                  className=""
                >
                  <h6
                    style={{
                      cursor: "pointer",
                      fontSize: "14px"
                    }}
                    className="text-primary font-bold text-end"
                    onClick={() => {
                      setIdentity('phone');
                    }}
                  >
                    
                    {STR_USE_PHONE[appContext.language]}
                  </h6>
                  
                  <h6
                    style={{
                      cursor: "pointer",
                      fontSize: "14px"
                    }}
                    className="text-primary font-bold text-end"
                    onClick={() => appContext.changeLanguage()}
                  >
                    
                    {STR_CHANGE_LANGUAGE[appContext.language]}
                    <MdTranslate size={24}/>
                  </h6>

                  
                </div>

              </div>
              :""
            }


            <div
              style={{
                paddingTop: "40px",
                paddingBottom: "40px",
              }}
              className="text-center"
            >
              <button 
                className="btn btn-rounded btn-padded btn-primary btn-block"
                style={{
                  fontSize: "16px",
                  textTransform: "uppercase"
                }}
                onClick={() => {
                  if(identity === 'email') {
                    emailLogin();
                  } else if(identity === 'phone') {
                    phoneLogin();
                  }
                }}
              >
                {STR_CONTINUE[appContext.language]}
              </button>
            </div>
          </div>
          :""
        }

        {
          (loginStep === 'otp') ?
          <div
            className="container"
            
          >
            <div
              className="text-center"
              style={{
                paddingTop: "var(--topBarHeight)",
                paddingBottom: "30px",
              }}
            >
              <img
                src={logo}
                style={{
                  width: "120px",
                  height: "auto",
                }}
                
              />
              <h6
                className="font-light"
                style={{
                  fontSize: "28px",
                }}
              >
                HOTELS
              </h6>
              <hr/>
              <h6
                className="font-bold text-primary"
                style={{
                  fontSize: "20px",
                }}
              >
                "<i>{STR_INTRO_2[appContext.language]}</i>"
              </h6>
            </div>

            <div
              style={{
                maxWidth: "420px",
                margin: "10px auto",
                padding: "30px",
                borderRadius: "20px"
              }}
              className="mShadow5 bg-surface"
            >

              <h6
                style={{
                  fontSize: "24px"
                }}
                className="font-bold"
              >
                {STR_YOUR_OTP_VERIFICATION[appContext.language]}!
              </h6>

              <div
                style={{
                  marginTop: "10px",
                  marginBottom: "30px",
                }}
              >
                <label>OTP</label>
                
                <input
                  className="form-control"
                  onChange={e => setOtp(e.target.value)}
                  value={otp}
                />
                <div className="form-text">
                  {STR_ENTER_OTP[appContext.language]}
                </div>
                
              </div>

              <div
                style={{
                  marginTop: "10px",
                  marginBottom: "30px",
                  display: (requestFullname) ? 'block' : 'none',
                }}
              >
                <label>{STR_FULLNAME[appContext.language]}</label>
                
                <input
                  className="form-control"
                  onChange={e => setFullname(e.target.value)}
                  value={fullname}
                />
                <div className="form-text">
                  {STR_ENTER_FULLNAME[appContext.language]}
                </div>
                
              </div>

              <div
                style={{
                  marginTop: "10px",
                  marginBottom: "30px",
                }}
              >
                <div className="row">
                  <div className="col-6">
                    <label>{STR_PASSWORD[appContext.language]}</label>
                
                    <input
                      className="form-control"
                      onChange={e => setPassword(e.target.value)}
                      value={password}
                      type="password"
                    />
                  
                  </div>

                  <div className="col-6">
                    <label>{STR_CONFIRM[appContext.language]}</label>
                
                    <input
                      className="form-control"
                      onChange={e => setConfirm(e.target.value)}
                      value={confirm}
                      type="password"
                    />
                  
                  </div>

                </div>
                
              </div>


              <div
                className=""
              >
                

                <h6
                  style={{
                    cursor: "pointer",
                    fontSize: "14px"
                  }}
                  className="text-primary font-bold"
                  onClick={() => {
                    setLoginStep('identity');

                  }}
                >
                  {STR_CHANGE_EMAIL_OR_PHONE[appContext.language]}
                </h6>

                <h6
                  style={{
                    cursor: "pointer",
                    fontSize: "14px"
                  }}
                  className="text-primary font-bold"
                  onClick={() => {
                    resendOtp()
                  }}
                >
                  {STR_RESEND_OTP[appContext.language]}
                </h6>

                <h6
                  style={{
                    cursor: "pointer",
                    fontSize: "14px"
                  }}
                  className="text-primary font-bold text-end"
                  onClick={() => appContext.changeLanguage()}
                >
                  
                  {STR_CHANGE_LANGUAGE[appContext.language]}
                  <MdTranslate size={24}/>
                </h6>
              </div>

            </div>


            <div
              style={{
                paddingTop: "40px",
                paddingBottom: "40px",
              }}
              className="text-center"
            >
              <button 
                className="btn btn-rounded btn-padded btn-primary btn-block"
                style={{
                  fontSize: "16px",
                  textTransform: "uppercase"
                }}
                onClick={otpLogin}
              >
                {STR_CONTINUE[appContext.language]}
              </button>
            </div>
          </div>
          :""
        }

        {
          (loginStep === 'password') ?
          <div
            className="container"
            
          >
            <div
              className="text-center"
              style={{
                paddingTop: "var(--topBarHeight)",
                paddingBottom: "30px",
              }}
            >
              <img
                src={logo}
                style={{
                  width: "120px",
                  height: "auto",
                }}
                
              />
              <h6
                className="font-light"
                style={{
                  fontSize: "28px",
                }}
              >
                HOTELS
              </h6>
              <hr/>
              <h6
                className="font-bold text-primary"
                style={{
                  fontSize: "20px",
                }}
              >
                "<i>{STR_INTRO_2[appContext.language]}</i>"
              </h6>
            </div>

            <div
              style={{
                maxWidth: "420px",
                margin: "10px auto",
                padding: "30px",
                borderRadius: "20px"
              }}
              className="mShadow5 bg-surface"
            >

              <h6
                style={{
                  fontSize: "24px"
                }}
                className="font-bold"
              >
                {STR_WELCOME_BACK[appContext.language]}!
              </h6>

              <div
                style={{
                  marginTop: "10px",
                  marginBottom: "30px",
                  display: (requestFullname) ? 'block' : 'none',
                }}
              >
                <label>{STR_FULLNAME[appContext.language]}</label>
                
                <input
                  className="form-control"
                  onChange={e => setFullname(e.target.value)}
                  value={fullname}
                />
                <div className="form-text">
                  {STR_ENTER_FULLNAME[appContext.language]}
                </div>
                
              </div>

              <div
                style={{
                  marginTop: "10px",
                  marginBottom: "30px",
                }}
              >
                
                <label>{STR_PASSWORD[appContext.language]}</label>
            
                <input
                  className="form-control"
                  onChange={e => setPassword(e.target.value)}
                  value={password}
                  type="password"
                />
                  
              </div>


              <div
                className=""
              >
                

                <h6
                  style={{
                    cursor: "pointer",
                    fontSize: "14px"
                  }}
                  className="text-primary font-bold"
                  onClick={() => {
                    setLoginStep('identity');

                  }}
                >
                  {STR_CHANGE_EMAIL_OR_PHONE[appContext.language]}
                </h6>

                <h6
                  style={{
                    cursor: "pointer",
                    fontSize: "14px"
                  }}
                  className="text-primary font-bold"
                  onClick={() => {
                    forgotPassword()
                  }}
                >
                  {STR_FORGOT_PASSWORD[appContext.language]}
                </h6>

                <h6
                  style={{
                    cursor: "pointer",
                    fontSize: "14px"
                  }}
                  className="text-primary font-bold text-end"
                  onClick={() => appContext.changeLanguage()}
                >
                  
                  {STR_CHANGE_LANGUAGE[appContext.language]}
                  <MdTranslate size={24}/>
                </h6>
              </div>

            </div>


            <div
              style={{
                paddingTop: "40px",
                paddingBottom: "40px",
              }}
              className="text-center"
            >
              <button 
                className="btn btn-rounded btn-padded btn-primary btn-block"
                style={{
                  fontSize: "16px",
                  textTransform: "uppercase"
                }}
                onClick={passwordLogin}
              >
                {STR_CONTINUE[appContext.language]}
              </button>
            </div>
          </div>
          :""
        }
      </div>
    </div >
  )
}